module.exports = __webpack_public_path__ + "static/media/fist-raised.ca55e056.svg";